import * as React from 'react'
import * as css from './ImageAndTextFeatured.module.css'
import { ImageAndText, Image, Text } from 'components/common/ImageAndText'
import SanityBlock from 'components/common/SanityBlock'
import CTALink from 'components/common/CTALink'

const ImageAndTextFeatured = ({ pretitle, title, _rawDescription, link, image }) => (
  <ImageAndText showHexPattern>
    <Image {...image} captionStyle={{ right: 'initial', left: 0 }} />

    <Text>
      {!!pretitle && <p className="technical-lg">{pretitle}</p>}
      {!!title && <h2 className={`${css.title} h0`}>{title}</h2>}
      <SanityBlock body={_rawDescription} />
      <CTALink {...link} />
    </Text>
  </ImageAndText>
)

export default ImageAndTextFeatured
